import { OPEN_LIGHTBOX, CLOSE_LIGHTBOX, CHANGE_LIGHTBOX_INDEX } from '../actions/types';

const INITIAL_STATE = {
  isOpen: false,
  images: [],
  imgIndex: 0,
};

export default (state = INITIAL_STATE, action) => {
  const { images, imgIndex = 0 } = action;
  switch (action.type) {
    case OPEN_LIGHTBOX:
      return {
        isOpen: true,
        images,
        imgIndex,
      };
    case CLOSE_LIGHTBOX:
      return {
        isOpen: false,
        images: [],
        imgIndex: 0,
      };
    case CHANGE_LIGHTBOX_INDEX:
      return {
        ...state,
        imgIndex,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/lightboxStateReducer.js